import { leadSourceCard, propertyDetailsCard } from '../../shared';
import type { DefaultCoverSheetConfig, LocaleOverrides } from '../../types';
import { leaseAgreementDatesCard, otherContactCard, rentCard } from '../shared';
import {
  buyerCard,
  buyersAgentCard,
  buyerTCCard,
  commissionDetailsCard,
  importantDatesCard,
  propertyBeingSoldCard,
  sellerCard,
  sellersAgentCard,
} from './cards';

export const BaseLandlordConfig = {
  version: '1',
  sections: {
    propertyInfo: {
      id: 'propertyInfo',
      header: 'Property Info',
      sidebarText: 'Property Info',
      cards: {
        propertyBeingSoldCard,
        importantDatesCard,
        leaseAgreementDatesCard,
        rentCard,
        commissionDetailsCard,
        leadSourceCard,
        propertyDetailsCard,
      },
    },
    sellerSideContacts: {
      id: 'sellerSideContacts',
      header: "Landlord's Contacts",
      sidebarText: 'Landlord Contacts',
      cards: {
        sellersAgentCard,
        sellerCard,
      },
    },
    buyerSideContacts: {
      id: 'buySideContacts',
      header: "Tenant's Contacts",
      sidebarText: 'Tenant Contacts',
      cards: {
        buyersAgentCard,
        buyerTCCard,
        buyerCard,
      },
    },
    additionalContacts: {
      id: 'additionalContacts',
      header: 'Additional Contacts',
      sidebarText: 'Additional Contacts',
      cards: {
        otherContactCard,
      },
    },
  },
} satisfies DefaultCoverSheetConfig;

export type LandlordLocaleOverrides = LocaleOverrides<
  typeof BaseLandlordConfig
>;
